import React, { Fragment } from "react";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";

function Productmenu() {
  return (
    <Fragment>
      <div className="row aboutmenu individuals">
        <div className="col-sm-12 button">
          {/* <Fade top delay={1000}>
            <Link
              to="/individualproduct/salammotor"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <h3
                data-aos="fade-up"
                data-aos-duration="4000"
                data-aos-easing="ease-out-cubic"
              >
                Salaam Motor Takaful
              </h3>
            </Link>
          </Fade> */}
          <Fade right delay={1500}>
            <Link
              to="/individualproduct/salamhome"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <h3
                data-aos="fade-left"
                data-aos-duration="4000"
                data-aos-easing="ease-out-cubic"
              >
                Salaam Home Takaful
              </h3>
            </Link>
          </Fade>

          <Fade left delay={2000}>
            <Link
              to="/individualproduct/salampersonal"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <h3
                data-aos="fade-right"
                data-aos-duration="4000"
                data-aos-easing="ease-out-cubic"
              >
                Salaam Personal Accident Takaful
              </h3>
            </Link>
          </Fade>

          <Fade left delay={2500}>
            <Link
              to="/individualproduct/salamsehat"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <h3
                data-aos="fade-right"
                data-aos-duration="4000"
                data-aos-easing="ease-out-cubic"
              >
                Salaam Sehat Takaful
              </h3>
            </Link>
          </Fade>
          <Fade left delay={3000}>
            <Link
              to="/individualproduct/salamtravel"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <h3
                data-aos="fade-right"
                data-aos-duration="4000"
                data-aos-easing="ease-out-cubic"
              >
                Salaam Travel
              </h3>
            </Link>
          </Fade>

          <Fade left delay={3500}>
            <Link
              to="/corporateproduct/salamlivestock"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <h3
                data-aos="fade-right"
                data-aos-duration="4000"
                data-aos-easing="ease-out-cubic"
              >
                Salaam Livestock Takaful
              </h3>
            </Link>
          </Fade>

          {/* <Fade left delay={4000}>
            <Link
              to="/corporateproduct/salamcrop"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <h3
                data-aos="fade-right"
                data-aos-duration="4000"
                data-aos-easing="ease-out-cubic"
              >
                Salaam Crop Takaful
              </h3>
            </Link>
          </Fade> */}
        </div>
      </div>
    </Fragment>
  );
}

export default Productmenu;
